import useAccountData from "hooks/useAccountData";
import { Company } from "models/Company";
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";


interface BreadcrumbCompanyProps {
    overrideId?: string;
}


export default function BreadcrumbCompany({ overrideId }: BreadcrumbCompanyProps) {
    let params = useParams();
    const { getCurrentCompany, loadingCompanies } = useAccountData();
    const [data, setData] = useState<Company | null>()

    const companyId = overrideId ?? (params.id as string);

    useEffect(() => {
        async function fetchData() {
            if (loadingCompanies) {
                const response = await getCurrentCompany(companyId);
                setData(response);
            }
        }
        fetchData();
    }, [getCurrentCompany, loadingCompanies, params.id]);
    return (
        <>
            {data === null ? (<></>) : (
                <>
                    <p className="text-secondary cc-company-name-details">
                        <Link to={UrlPath.MyAccount.Home}>
                            <small>{data?.name} Org nr: {data?.companyCode}. Juridisk navn: {data?.legalName}</small>
                        </Link>
                    </p>
                </>
            )}
        </>);
}
